<script setup lang="ts">
    import type { FormSelectOption } from '~/components/atm/FormSelectOptions.vue';

    export interface FormSelectOptionsValueBase {
        optionMultiLine?: boolean;
        translate?: (label: string) => string;
        prefixComponent?: Component<{ option: FormSelectOption }>;
        postfixComponent?: Component<{ option: FormSelectOption }>;
    }
    export interface FormSelectOptionsValueProps extends FormSelectOptionsValueBase {
        option: FormSelectOption;
        selected?: boolean;
        isCrankset?: boolean;
    }

    const props = withDefaults(defineProps<FormSelectOptionsValueProps>(), {
        translate: (label: string) => label,
    });

    const optionLabel = (option: FormSelectOption) => {
        return props.translate(option.label || option.value);
    };
</script>

<template>
    <div class="flex items-center gap-2">
        <component
            v-if="prefixComponent"
            :is="prefixComponent"
            :option="option" />
        <span :class="[selected ? 'font-bold text-woom-red' : 'font-normal', 'block', { truncate: !optionMultiLine }]">
            <renderer-html :content="woomTextFormat(optionLabel(option))" />
        </span>
        <component
            v-if="postfixComponent"
            :is="postfixComponent"
            :option="option" />
    </div>
</template>
